import { render, staticRenderFns } from "./valueAddedServices.vue?vue&type=template&id=4b34ebdc&"
import script from "./valueAddedServices.vue?vue&type=script&lang=js&"
export * from "./valueAddedServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b34ebdc')) {
      api.createRecord('4b34ebdc', component.options)
    } else {
      api.reload('4b34ebdc', component.options)
    }
    module.hot.accept("./valueAddedServices.vue?vue&type=template&id=4b34ebdc&", function () {
      api.rerender('4b34ebdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/valueAddedServices.vue"
export default component.exports